"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function ryo(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M12.0007 3.01123C7.04323 3.01123 3.01123 7.04323 3.01123 12.0007C3.01123 16.9582 7.04323 20.9887 12.0007 20.9887C16.9582 20.9887 20.9887 16.9575 20.9887 12.0007C20.9895 7.04323 16.9575 3.01123 12.0007 3.01123ZM12.0007 4.23523C13.0208 4.23395 14.0312 4.43394 14.9739 4.82374C15.9166 5.21355 16.7731 5.78552 17.4944 6.50688C18.2157 7.22824 18.7875 8.08481 19.1773 9.02754C19.567 9.97027 19.7669 10.9806 19.7655 12.0007C19.7668 13.0208 19.5668 14.031 19.177 14.9737C18.7873 15.9163 18.2154 16.7728 17.4941 17.4941C16.7728 18.2154 15.9163 18.7873 14.9737 19.177C14.031 19.5668 13.0208 19.7668 12.0007 19.7655C10.9806 19.7669 9.97027 19.567 9.02754 19.1773C8.08481 18.7875 7.22824 18.2157 6.50688 17.4944C5.78552 16.7731 5.21355 15.9166 4.82374 14.9739C4.43394 14.0312 4.23395 13.0208 4.23523 12.0007C4.23395 10.9806 4.43393 9.97022 4.82373 9.02748C5.21353 8.08475 5.78548 7.22818 6.50683 6.50683C7.22818 5.78548 8.08475 5.21353 9.02748 4.82373C9.97022 4.43393 10.9806 4.23395 12.0007 4.23523Z", fill: color }),
        React.createElement("path", { d: "M8.66089 8.68127V15.3188H15.3396V8.68127H8.66089ZM9.74839 9.76877H14.2514V14.2313H9.74914V9.76877H9.74839Z", fill: color }));
}
exports["default"] = ryo;
//# sourceMappingURL=ryo.js.map